// extracted by mini-css-extract-plugin
export default {"placeholder":"index_placeholder_jmtSc","wrap":"index_wrap_eCNZf"};